<template>
  <layout name="LoginLayout">
    <v-card class="elevation-12">

      <the-alert />

      <v-card-text>
        <v-form>
          <v-text-field
            label="Usuario"
            name="login"
            prepend-icon="mdi-account"
            type="text"
            :rules="[v => !!v || 'Email is required']"
            v-model="username"
            required
            @change="clearAlert"
          />

          <v-text-field
            id="password"
            label="Contraseña"
            name="password"
            prepend-icon="mdi-lock"
            @click:append="() => (passwordType = !passwordType)"
            :append-icon="passwordType ? 'mdi-eye-off' : 'mdi-eye'"
            :type="passwordType ? 'password' : 'text'"
            :rules="[v => !!v || 'Password is required']"
            v-model="password"
            required
            @change="clearAlert"
          />
          <v-card-actions
            class="justify-center"
          >
            <v-btn
              color="primary"
              text
              dark
              :disabled="!username || !password"
              @click.prevent="doLogin"
            >
              Entrar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      passwordType: true
    }
  },
  components: {
    Layout,
    TheAlert: () => import(/* webpackChunkName: "the-alert" */ '@/components/TheAlert')
  },
  computed: {
    isLoggedIn: () => this.$store.getters.isLoggedIn
  },
  methods: {

    async doLogin() {
      let { username, password } = this
      await this.$store.dispatch('Auth/LOGIN', { username, password })
        .then(() => this.$router.push('/'))
        .catch(() => this.$store.dispatch('Alert/ADD', 'Usuario/contraseña incorrectos'))
    },

    clearAlert() {
      this.$store.dispatch('Alert/CLEAR')
    }
    
  },
}
</script>